// Keep each near-viewport upgrade small enough to avoid a visible input stall when
// media-heavy rows mount together. Measured spacers still preserve exact geometry.
export const NATURAL_FEED_SEGMENT_SIZE = 2

export type NaturalFlowSegment<T> = {
    key: string
    rows: T[]
}

export type NaturalFeedSegment<T> = NaturalFlowSegment<T>

type NaturalFlowSegmentOptions = {
    keyPrefix: string
    segmentSize: number
}

export function buildNaturalFlowSegments<T>(
    rows: T[],
    getRowKey: (row: T, index: number) => string,
    { keyPrefix, segmentSize }: NaturalFlowSegmentOptions,
): NaturalFlowSegment<T>[] {
    const resolvedSegmentSize = Math.max(1, Math.floor(segmentSize) || 1)
    const segments: NaturalFlowSegment<T>[] = []

    for (let start = 0; start < rows.length; start += resolvedSegmentSize) {
        const segmentRows = rows.slice(start, start + resolvedSegmentSize)
        const firstKey = getRowKey(segmentRows[0], start)
        segments.push({
            // Appends commonly extend the final partial segment. Its identity must not
            // change when that happens or React remounts every already-visible row in it.
            key: `${keyPrefix}:${Math.floor(start / resolvedSegmentSize)}:${firstKey}`,
            rows: segmentRows,
        })
    }

    return segments
}

export function buildNaturalFeedSegments<T>(
    rows: T[],
    getRowKey: (row: T, index: number) => string,
    segmentSize = NATURAL_FEED_SEGMENT_SIZE,
): NaturalFeedSegment<T>[] {
    return buildNaturalFlowSegments(rows, getRowKey, {
        keyPrefix: 'natural-feed',
        segmentSize,
    })
}
